import { MainTemplate } from 'templates/MainTemplate'

export const SkeletonHome = () => {
  return (
    <MainTemplate>
      <section className="w-full p-20 flex justify-around gap-10 flex-nowrap">
        <div className="p-4 space-y-4 animate-pulse w-1/3">
          <div className="w-full h-40 bg-gray-200 dark:bg-gray-500 rounded"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
          </div>
        </div>

        <div className="p-4 space-y-4 animate-pulse w-1/3">
          <div className="w-full h-40 bg-gray-200 dark:bg-gray-500 rounded"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
          </div>
        </div>

        <div className="p-4 space-y-4 animate-pulse w-1/3">
          <div className="w-full h-40 bg-gray-200 dark:bg-gray-500 rounded"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-11/12"></div>
          </div>
        </div>
      </section>
    </MainTemplate>
  )
}
